export const SnapdocsClosingSectionTestIds = {
  SECTION: 'snapdocs-closing.section',
  REFRESH_BUTTON: 'snapdocs-closing.refresh-button',
  LOADING_SKELETON: 'snapdocs-closing.loading-skeleton',
  NO_CLOSING_ROW: 'snapdocs-closing.no-closing-row',
  UNAVAILABLE_ROW: 'snapdocs-closing.unavailable-row',
  ERROR_MESSAGE: 'snapdocs-closing.error-message',
  RETRY_BUTTON: 'snapdocs-closing.retry-button',
  SUMMARY: 'snapdocs-closing.summary',
  BORROWERS_TABLE: 'snapdocs-closing.borrowers-table',
  DETAILS_PANEL: 'snapdocs-closing.details-panel',
  QUALITY_CONTROL_BLOCK: 'snapdocs-closing.quality-control-block',
  COMMENTS_BLOCK: 'snapdocs-closing.comments-block',
  AUDIT_TRAIL_BLOCK: 'snapdocs-closing.audit-trail-block',
  AUDIT_TRAIL_LOADING: 'snapdocs-closing.audit-trail-loading',
  AUDIT_TRAIL_EMPTY: 'snapdocs-closing.audit-trail-empty',
  AUDIT_TRAIL_RETRY_BUTTON: 'snapdocs-closing.audit-trail-retry-button',
  AUDIT_TRAIL_ERROR: 'snapdocs-closing.audit-trail-error',
  AUDIT_TRAIL_TABLE: 'snapdocs-closing.audit-trail-table',
};
